/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC721Handler, ERC721HandlerInterface } from "../ERC721Handler";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "ContractAddressNotWhitelisted",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "actual",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expected",
        type: "uint256",
      },
    ],
    name: "UnexpectedValue",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToTokenContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_tokenContractAddressToTokenProperties",
    outputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "isWhitelisted",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isBurnable",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "isSet",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "externalDecimals",
            type: "uint8",
          },
        ],
        internalType: "struct ERCHandlerHelpers.Decimals",
        name: "decimals",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "defaultDecimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "setBurnable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "bytes",
        name: "metaData",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "executeProposal",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "args",
        type: "bytes",
      },
    ],
    name: "setResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC721HandlerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721HandlerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721Handler__factory extends ContractFactory {
  constructor(...args: ERC721HandlerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ERC721Handler";
  }

  deploy(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721Handler> {
    return super.deploy(
      bridgeAddress,
      overrides || {}
    ) as Promise<ERC721Handler>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(bridgeAddress, overrides || {});
  }
  attach(address: string): ERC721Handler {
    return super.attach(address) as ERC721Handler;
  }
  connect(signer: Signer): ERC721Handler__factory {
    return super.connect(signer) as ERC721Handler__factory;
  }
  static readonly contractName: "ERC721Handler";
  public readonly contractName: "ERC721Handler";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721HandlerInterface {
    return new utils.Interface(_abi) as ERC721HandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721Handler {
    return new Contract(address, _abi, signerOrProvider) as ERC721Handler;
  }
}
